// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"801dc4f7","952":"eff41b49"}[chunkId] + ".chunk.js";
};